import { AccordionHeader } from "@crabs-ai/ds-react";
import { useTranslations } from "next-intl";
import { TimingControls } from "../../vendor/src/features/remotion-editor/editor/inspector/controls/timing-controls";
import { CollapsibleContent } from "../../vendor/src/features/remotion-editor/editor/inspector/collapsible-content";
import { useInspectorSections } from "../../vendor/src/features/remotion-editor/editor/inspector/use-inspector-sections";
const defaults = { time: true };

export function TimingSection({
  itemId,
  collapseAllTrigger,
  expandAllTrigger,
}: {
  itemId: string;
  collapseAllTrigger: number;
  expandAllTrigger: number;
}) {
  const t = useTranslations();
  const { openSections, toggleSection } = useInspectorSections({
    itemId,
    defaults,
    collapseAllTrigger,
    expandAllTrigger,
  });
  return (
    <section
      aria-label={t("Editor.inspector.timing.title")}
      className="border-b border-sys-style-neutral-light px-4xs pb-2xs"
    >
      <AccordionHeader
        size="sm"
        title={t("Editor.inspector.timing.title")}
        isOpened={openSections.time}
        onClick={() => toggleSection("time")}
      />
      <CollapsibleContent isOpen={openSections.time}>
        <div className="px-md py-4xs">
          <TimingControls itemId={itemId} />
        </div>
      </CollapsibleContent>
    </section>
  );
}
